import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";
import { useRootAppStore } from "@hooks";
import { WrappedNavLink } from "@components/navigation";
import { HeaderGamesNavItem } from "./HeaderGamesNavItem";
import { useAppContext } from "@state/hooks/shared";

export default observer(function HeaderNavigation(props: {
	onTargetClick?: (target: "live" | "sports") => void;
}) {
	const { culture } = useAppContext();
	const rootStore = useRootAppStore();
	const { t } = useTranslation();

	return (
		<nav className="header__nav">
			<ul className="nav--primary">
				<li className="nav--primary__item">
					<WrappedNavLink
						to={`/${culture}/${DefaultPath.HOME}`}
						className="nav--primary__link"
						activeClassName="is-active"
						isActive={(match, location) =>
							location.pathname.includes(`/home/`)
						}
					>
						{t("HOME.HOME")}
					</WrappedNavLink>
				</li>
				<li className="nav--primary__item">
					<WrappedNavLink
						to={`/${culture}/sports/`}
						className="nav--primary__link"
						activeClassName="is-active"
						isActive={(match, location) => {
							return (
								location.pathname.includes(
									`/${culture}/sports/`
								) || match != null
							);
						}}
						onClick={() => props.onTargetClick?.("sports")}
					>
						{t("HOME.SPORTS_BETTING")}
					</WrappedNavLink>
				</li>
				<li className="nav--primary__item">
					<WrappedNavLink
						to={`/${culture}/${DefaultPath.LIVE}`}
						className="nav--primary__link"
						activeClassName="is-active"
						isActive={(match, location) =>
							location.pathname == `/${culture}/live` ||
							match != null
						}
						onClick={() => props.onTargetClick?.("live")}
					>
						{t("HOME.LIVE_BETTING")}
					</WrappedNavLink>
				</li>

				{WEBPACK_IS_GAMES_ENABLED && <HeaderGamesNavItem />}

				{WEBPACK_IS_CASINO_ENABLED &&
					(rootStore.userAuthStore.user == null ||
						rootStore.userAuthStore.isInternetUser) && (
						<li className="nav--primary__item">
							<WrappedNavLink
								to={`/${culture}/games`}
								className="nav--primary__link"
								activeClassName="is-active"
								isActive={(match, location) =>
									location.pathname == `/${culture}/games` ||
									match != null
								}
							>
								{t("specific:HEADER.CASINO")}
							</WrappedNavLink>
						</li>
					)}

				{WEBPACK_IS_CASINO_LIVE_ENABLED &&
					(rootStore.userAuthStore.user == null ||
						rootStore.userAuthStore.isInternetUser) && (
						<li className="nav--primary__item">
							<WrappedNavLink
								to={`/${culture}/live-games`}
								className="nav--primary__link"
								activeClassName="is-active"
								isActive={(match, location) =>
									location.pathname ==
										`/${culture}/live-games` ||
									match != null
								}
							>
								{t("specific:HEADER.CASINO-LIVE")}
							</WrappedNavLink>
						</li>
					)}
			</ul>
		</nav>
	);
});
